<div class="rst-pwd-container">
  <mat-card class="rst-pwd-form-container">
    <form class="rst-pwd-form" [formGroup]="_form" (ngSubmit)="reset_password()">
      <!-- Label -->
      <div class="rst-pwd-title">
        <ddc-text-gradient class="text-xl" [_text]="_pageCardTitle" [_type]="'1'"> </ddc-text-gradient>
        <p class="text-sm">{{ _pageCardText }}</p>
      </div>
      <!-- ! Form Error -->
      <div class="alert alert-danger" *ngIf="_form.errors?.['passwordMatchError']">Passwords do not match</div>
      <!-- ! Password -->
      <mat-form-field class="rst-pwd-code" *ngIf="!_isResetSuccessful">
        <mat-label>Password</mat-label>
        <input aria-label="password" formControlName="_password" matInput [type]="_hide ? 'password' : 'text'" />
        <button
          mat-icon-button
          matSuffix
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="_hide"
          (click)="_hide = !_hide"
        >
          <mat-icon>{{ _hide ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <mat-error *ngIf="password.hasError('pattern')">
          Password must have at least one <strong>lowercase</strong> letter, <strong>uppercase</strong> letter,
          <strong>number</strong> and <strong>special character</strong>(#-_+). At least 8 characters.
        </mat-error>
        <mat-error *ngIf="password.hasError('required')"> Password is <strong>required</strong> </mat-error>
      </mat-form-field>
      <!-- ! Confirm Password  -->
      <mat-form-field class="rst-pwd-code" *ngIf="!_isResetSuccessful">
        <mat-label>Confirm Password</mat-label>
        <input
          aria-label="confirmPassword"
          formControlName="_confirmPassword"
          matInput
          [type]="_hideConfirm ? 'password' : 'text'"
        />
        <button
          mat-icon-button
          matSuffix
          [attr.aria-label]="'Toggle confirm password visibility'"
          [attr.aria-pressed]="_hideConfirm"
          (click)="_hideConfirm = !_hideConfirm"
        >
          <mat-icon>{{ _hideConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <mat-error *ngIf="confirmPassword.hasError('required')">
          Confirm Password is <strong>required</strong>
        </mat-error>
        <mat-error *ngIf="confirmPassword.hasError('passwordMatchError')"> Passwords do not match </mat-error>
      </mat-form-field>
      <!-- ! Submit button -->
      <!-- <button
            *ngIf="!_isResetSuccessful"
            [disabled]="_isSendResetPasswordEmailBtnLoading"
            (click)="reset_password()"
            mat-flat-button
        >
            <i
                class="material-icons"
                *ngIf="_isSendResetPasswordEmailBtnLoading"
            >person_search</i>
            {{_sendResetPasswordEmailBtnText}}
        </button> -->
      <ddc-button-s-one
        *ngIf="!_isResetSuccessful"
        [_icon]="'login'"
        [_isLoading]="_isResetPasswordBtnLoading"
        [_label]="_submitBtnText"
        (buttonClick)="reset_password()"
      ></ddc-button-s-one>
    </form>
    <!-- ! Route -->
    <div class="rst-pwd-rst-pwd" *ngIf="_isResetSuccessful">
      <ddc-button-r-one
        class="rst-pwd-rst-pwd-button"
        [dynamicRoute]="'/login'"
        [icon]="'login'"
        [label]="'To Login Page'"
        [type]="'route'"
      >
      </ddc-button-r-one>
    </div>
  </mat-card>
</div>
